import { getImageFile } from '@/utils';
import * as THREE from 'three';
import { ref, watch } from 'vue';

/**
 * plane 尺寸
 */
const PLANE_SIZE = 7;

const PLANE_POSITION = new THREE.Vector3(-1.5, 0, -5);

let texture: THREE.Texture;
export function usePlane(scene: THREE.Scene) {

    let plane: THREE.Mesh<THREE.PlaneGeometry, THREE.MeshBasicMaterial, THREE.Object3DEventMap>

    const opacity = ref(0);

    function loadPlaneTexture() {
        const textureLoader = new THREE.TextureLoader();
        textureLoader.load(getImageFile('ring.png'), result => {
            texture = result;
            texture.colorSpace = THREE.SRGBColorSpace;
        })
    }

    function showPlane() {
        const geometry = new THREE.PlaneGeometry(PLANE_SIZE, PLANE_SIZE);
        const material = new THREE.MeshBasicMaterial({
            opacity: opacity.value,
            map: texture, 
            transparent: true,
            depthWrite: false,
        });
        plane = new THREE.Mesh(geometry, material);
        plane.position.copy(PLANE_POSITION);
        scene.add(plane);
        function animate() {
            requestAnimationFrame(animate);
            plane.rotateZ(0.01);
            if (opacity.value < 1) opacity.value += 0.01;
        }
        requestAnimationFrame(animate);
    }
    watch(opacity, newVal => plane.material.opacity = newVal);

    function hidePlane() {
        plane.visible = false;
    }

    return {
        loadPlaneTexture,
        showPlane,
        hidePlane,
    }
}